module.exports = __webpack_public_path__ + "img/foot_jicha.012e43ad.png";